import React from "react";

function Modal({ closeModal, title, children }: { closeModal: any, title: string, children: React.ReactNode }) {

  return (
    <div className="fixed top-0 left-0 w-screen h-screen grid place-items-center bg-black bg-opacity-50 p-4 md:p-10 z-50">
      <div className="w-full md:w-[700px] max-h-[90vh] overflow-y-auto bg-white rounded-2xl md:rounded-[32px] p-6 md:p-8 relative">
        <h3 className="text-xl  text-gray-900 mb-4 flex items-start justify-between">
          {title}
          <button
            onClick={() => closeModal(false)}
            className="bi bi-x-lg text-darkBlue px-4 md:px-6 py-2 rounded cursor-pointer"
          />
        </h3>
        {/* ensure modal content uses text-md by default */}
        <div className="text-md">
          {children}
        </div>
      </div>
    </div>
  );
}

export default Modal;